import { module } from 'modujs';
import modularLoad from 'modularload';
import { html } from '../utils/environment';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.load = new modularLoad({
            enterDelay: 750,
            transitions: {
                customTransition: {},
                list: {
                    enterDelay: 500
                }
            }
        });

        this.load.on('loading', (transition, oldContainer)  => {
            this.call('closeMenu', null, 'Header')
            html.classList.remove('has-scrolled')

            if (transition == 'list') {
                this.call('scrollTo', { target: oldContainer.parentNode }, 'Scroll')
            } else {
                this.call('setState', 'loader', 'Header')
            }
        })

        this.load.on('loaded', (transition, oldContainer, newContainer) => {
            this.call('destroy', oldContainer, 'app');
            this.call('update', newContainer, 'app');

            if (transition != 'list') {
                this.call('setState', 'idle', 'Header')
            }
        });

        this.load.on('ready', (transition) => {
            if(['list'].includes(transition)) {
                this.call('update', null, 'Scroll')
            }
        })
    }

    goTo(obj) {
        this.load.goTo(obj.url, obj.transition);
    }
}
